import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Toolbar, Button, Icon, DialogActions, IconButton, MenuItem } from 'material-ui';
import ReactTable from "react-table";
import classNames from 'classnames';
import Formsy from 'formsy-react';
import { TextFieldFormsy, CheckboxFormsy, SelectFormsy } from '@fuse';
import axios from 'axios';
import { withAlert } from 'react-alert';
import Loader from "other-components/loader/loader";
import 'react-select/dist/react-select.css'
import { confirmAlert } from 'react-confirm-alert';

import { Typography, AppBar } from 'material-ui';
import CloseIcon from '@material-ui/icons/Close';
import Dialog, {
    DialogContent,
} from 'material-ui/Dialog';

class pettyCashBook extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            editObj: {},
        };

        // this.setSelectedJob = this.setSelectedJob.bind(this);

    }

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };

    addBook = (data) => {
        this.setState({ loading: true });
        //  axios.post('http://localhost:5009/pettyCash/addPettyCashBook',data)
        axios.post(window.accountServer + '/pettyCash/addPettyCashBook', data)
            .then(res => {
                if (res.data.status) {
                    this.getBook();
                    this.setState({ loading: false });
                    this.props.alert.success(res.data.msg);
                }

                else {
                    this.getBook();
                    this.setState({ loading: false });
                    this.props.alert.error(res.data.msg);
                }
            })
    }

    getBook = () => {

        this.setState({ loading: true });
        var category = [];
        // axios.get('http://localhost:5009/pettyCash/getPettyCashBook')
        axios.get(window.accountServer + '/pettyCash/getPettyCashBook')
            .then(response => {

                this.setState({ bookList: response.data });
                this.setState({ loading: false });
            })
    }

    activateBook = (id) => {


        confirmAlert({
            title: 'Confirm to Activate',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.activate(id)
                },
                {
                    label: 'No'
                }
            ]
        })

    }

    activate = (id) => {

        var category = [];
        // axios.post('http://localhost:5009/pettyCash/activatePettyCashBook',{'id':id})
        axios.post(window.accountServer + '/pettyCash/activatePettyCashBook', { 'id': id })
            .then(res => {
                if (res.data.status) {
                    this.getBook();
                    this.setState({ loading: false });
                    this.props.alert.success(res.data.msg);
                }

                else {
                    this.getBook();
                    this.setState({ loading: false });
                    this.props.alert.error(res.data.msg);
                }
            })
    }

    diactivateBook = (id) => {


        confirmAlert({
            title: 'Confirm to Diactivate',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.diactivate(id)
                },
                {
                    label: 'No'
                }
            ]
        })

    }

    diactivate = (id) => {

        var category = [];
        // axios.post('http://localhost:5009/pettyCash/diactivatePettyCashBook',{'id':id})
        axios.post(window.accountServer + '/pettyCash/diactivatePettyCashBook', { 'id': id })
            .then(res => {
                if (res.data.status) {
                    this.getBook();
                    this.setState({ loading: false });
                    this.props.alert.success(res.data.msg);
                }

                else {
                    this.getBook();
                    this.setState({ loading: false });
                    this.props.alert.error(res.data.msg);
                }
            })
    }

    // edit petty cash book
    onEdit = (model) => {
        this.editPettyCashBook(model);
    };

    editPettyCashBook(model) {
        this.setState({ loading: true });
        console.log('edit model',model);
        axios.post(window.accountServer +'/pettyCash/editPettyCashBook', model)
        // axios.post(window.hrmServer + '/editEmployeePersnolDatail', editEmpPresnolDetail)
            .then(res => {
                this.setState({ loading: false });

                if (res.data.success) {
                    this.handleCloseEdit();
                    this.props.alert.success("Updated Successfully");
                    this.getBook();
                } else {
                    this.handleCloseEdit();
                    this.props.alert.error("Unable to Update Please Check");
                    this.getBook();
                }
            }).catch(function (error) {
                this.setState({ loading: false });
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                this.handleCloseEdit();
                this.props.alert.error("Unable to Update");
                this.getBook();
                // alert("No internet connection or Internal error");
            });
    }

    render() {
        const { classes } = this.props;

        if (this.state.loading) {
            return (

                <Loader />

            );
        }
        else {

            return (

                <React.Fragment>

                    <Toolbar className="flex flex-wrap pt-24 px-12">
                        <h2 className="w-full sm:w-1/4 subtitle-color ">
                            Petty Cash Book
                        </h2>
                    </Toolbar>
                    <Formsy
                        onValidSubmit={this.addBook}
                    >
                        <div className="block petticash-form-margin-two ">
                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                <TextFieldFormsy
                                    type="text"
                                    name="bookCode"
                                    label="Book Code"
                                    required
                                />
                            </div>
                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                <TextFieldFormsy
                                    type="text"
                                    name="bookName"
                                    label="Petty Cash Book Name"
                                    required
                                />
                            </div>
                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                <TextFieldFormsy
                                    type="text"
                                    name="bookDes"
                                    label="Description"
                                    required
                                />
                            </div>
                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                <TextFieldFormsy
                                    type="text"
                                    name="raimbusmentAmount"
                                    label="Reimbursment Amount"
                                    required
                                />
                            </div>
                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                <TextFieldFormsy
                                    type="text"
                                    name="bufferLevel"
                                    label="Buffer Level"
                                    required
                                />
                            </div>

                        </div>
                        <div className="block petticash-form-margin-two">

                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                <SelectFormsy
                                    name="duration"
                                    label="Duration"
                                    value="Monthly"
                                    required
                                >
                                    <MenuItem className="popup-value-size" key='1' value='Daily'>Daily</MenuItem>
                                    <MenuItem className="popup-value-size" key='2' value='Weekly'>Weekly</MenuItem>
                                    <MenuItem className="popup-value-size" key='3' value='Monthly'>Monthly</MenuItem>
                                    <MenuItem className="popup-value-size" key='4' value='Quartly'>Quartly</MenuItem>
                                    <MenuItem className="popup-value-size" key='5' value='Yearly'>Yearly</MenuItem>
                                </SelectFormsy>
                            </div>
                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                <CheckboxFormsy
                                    className=""
                                    name="isActive"
                                    value="true"
                                    label="Active"
                                />
                            </div>

                        </div>

                        <DialogActions className="justify-right">
                            <Button
                                type="submit"
                                variant="raised"
                                color="secondary"
                            >
                                Save
                          </Button>
                            <Button
                                type="reset"
                                variant="raised"
                                color="primary"
                            >
                                Clear
                          </Button>
                            <Button
                                variant="raised"
                                color="default"
                            >
                                Help
                          </Button>
                        </DialogActions>

                    </Formsy>

                    <div class="flex h-auto mt-4">

                        <div class="w-full bg-white h-auto">
                            <ReactTable
                                className={classNames(classes.root, "-striped -highlight m-12 p-20 border-2 border-green-darkest")}
                                getTrProps={(state, rowInfo, column) => {
                                    return {
                                        className: "cursor-pointer",
                                    }
                                }}
                                data={this.state.bookList}
                                columns={[
                                    {
                                        Header: "Book Code",
                                        accessor: "CODE",
                                        filterable: true,
                                        className: '',
                                        width: 200,
                                        Cell: ({ row, original }) => (
                                            <span>
                                                <span style={{

                                                    color: original.IS_ACTIVE == 1 ? '#57d500' : '#Ff0000',
                                                    transition: 'all .3s ease'
                                                }}>
                                                    &#x25cf;
                                        </span>
                                                {
                                                    row.value == '' ? ' '
                                                        : row.CODE
                                                }
                                            </span>
                                        )
                                    },
                                    {
                                        Header: "ID",
                                        accessor: "ID_LEDGER_ACCOUNT",
                                        filterable: true,
                                        show : true,
                                        className: "",
                                    },
                                    {
                                        Header: "Petty Cash Book",
                                        accessor: "NAME",
                                        filterable: true,
                                        className: "",
                                    },
                                    {
                                        Header: "Reimbursment Amount",
                                        accessor: "REIMBURSE_AMOUNT",
                                        filterable: true,
                                        className: "",
                                    },
                                    {
                                        Header: "Buffer Level",
                                        accessor: "BUFFER_LEVEL",
                                        filterable: true,
                                        className: "",
                                    },
                                    {
                                        Header: "Duration",
                                        accessor: "DURATION",
                                        filterable: true,
                                        className: "",
                                    },
                                    {
                                        Header: "Actions",
                                        width: 128,
                                        Cell: row => (

                                            <div className="flex items-center w-8 h-8">
                                                {row.original.IS_ACTIVE === 1 ? (
                                                    <div className="flex items-center">
                                                        <IconButton
                                                            title='Edit'
                                                            onClick={(ev) => {
                                                                ev.stopPropagation();
                                                                // this.editPettyCashBook(row.original.NAME);
                                                                this.setState({ editObj: row.original })
                                                                this.setState({ edit: true });
                                                                // this.removeContactPersonEdit();
                                                                // this.openNewCustomerDialogEdit(row.original);
                                                            }}
                                                        >
                                                            <Icon className='text-blue'>mode_edit</Icon>
                                                        </IconButton>
                                                        <IconButton
                                                            title='Diactivate'
                                                            onClick={(ev) => {
                                                                ev.stopPropagation();
                                                                this.diactivateBook(row.original.ID_PETTY_CASH_BOOK);
                                                            }}
                                                        >
                                                            <Icon className='text-green-light'>
                                                                check_circle
                                                            </Icon>
                                                        </IconButton>

                                                        <Dialog

                                                            open={this.state.edit}
                                                            onClose={this.handleCloseEdit}
                                                            aria-labelledby="form-dialog-title"
                                                        >

                                                            <AppBar className="flex w-full h-50 app-bar-size" position="static">
                                                                <Toolbar className="flex w-full ">
                                                                    <Typography className="w-full personl-details-head-margin" variant="subheading" color="inherit">
                                                                        Edit Petty Cash Book
                                                                    </Typography>
                                                                    <IconButton className="" color="inherit" onClick={this.handleCloseEdit} aria-label="Close">
                                                                        <CloseIcon />
                                                                    </IconButton>
                                                                </Toolbar>
                                                            </AppBar>

                                                            <Formsy
                                                                onValidSubmit={this.onEdit}
                                                                onValid={this.enableButtonEdit}
                                                                onInvalid={this.disableButtonEdit}
                                                                ref={(form) => this.form = form}
                                                                className=""
                                                            >

                                                                <DialogContent className="flex flex-wrap">

                                                                    <div className="block ">
                                                                        <div className="w-full sm:w-1/2 md:w-1/2 p-8 inline-block">
                                                                        {/* ID_PETTY_CASH_BOOK */}

                                                                        <TextFieldFormsy
                                                                                type="text"
                                                                                name="bookId"
                                                                                className="petty-cash-edit"
                                                                                label="Id"
                                                                                value={this.state.editObj.ID_PETTY_CASH_BOOK}
                                                                                required
                                                                                disabled
                                                                            />

                                                                            <TextFieldFormsy
                                                                                type="text"
                                                                                name="bookCode"
                                                                                label="Book Code"
                                                                                value={this.state.editObj.CODE}
                                                                                required
                                                                            />

                                                                        </div>
                                                                        <div className="w-full sm:w-1/2 md:w-1/4 p-8 inline-block">

                                                                            <TextFieldFormsy
                                                                                type="text"
                                                                                name="bookName"
                                                                                label="Petty Cash Book Name"
                                                                                value={this.state.editObj.NAME}
                                                                                required
                                                                            />
                                                                        </div>
                                                                       
                                                                        <div className="w-full sm:w-1/2 md:w-1/2 p-8 inline-block">

                                                                            <TextFieldFormsy
                                                                                type="text"
                                                                                name="raimbusmentAmount"
                                                                                label="Reimbursment Amount"
                                                                                value={this.state.editObj.REIMBURSE_AMOUNT}
                                                                                required
                                                                            />
                                                                        </div>
                                                                        <div className="w-full sm:w-1/2 md:w-1/4 p-8 inline-block">

                                                                            <TextFieldFormsy
                                                                                type="text"
                                                                                name="bufferLevel"
                                                                                label="Buffer Level"
                                                                                value={this.state.editObj.BUFFER_LEVEL}
                                                                                required
                                                                            />
                                                                        </div>

                                                                    </div>
                                                                    <div className="block">

                                                                        <div className="w-full sm:w-1/2 md:w-1/2 p-8 inline-block">

                                                                            <SelectFormsy
                                                                                name="duration"
                                                                                label="Duration"
                                                                                value="Monthly"
                                                                                required
                                                                            >
                                                                                <MenuItem className="popup-value-size" key='1' value='Daily'>Daily</MenuItem>
                                                                                <MenuItem className="popup-value-size" key='2' value='Weekly'>Weekly</MenuItem>
                                                                                <MenuItem className="popup-value-size" key='3' value='Monthly'>Monthly</MenuItem>
                                                                                <MenuItem className="popup-value-size" key='4' value='Quartly'>Quartly</MenuItem>
                                                                                <MenuItem className="popup-value-size" key='5' value='Yearly'>Yearly</MenuItem>
                                                                            </SelectFormsy>
                                                                        </div>
                                                                        {/* <div className="w-full sm:w-1/2 md:w-1/4 p-8 inline-block">

                                                                            <CheckboxFormsy
                                                                                className=""
                                                                                name="isActive"
                                                                                value="true"
                                                                                label="Active"
                                                                            />
                                                                        </div> */}

                                                                    </div>

                                                                </DialogContent>
                                                                <DialogActions>                                                              
                                                                    <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} md:h-24 ">
                                                                        Update
                                                                        </Button>
                                                                        <Button type="button" onClick={this.handleCloseEdit} variant="raised" size="small" color="primary" className="{classes.button}  md:h-24">
                                                                        Close
                                                                    </Button>    
                                                                </DialogActions>
                                                            </Formsy>
                                                        </Dialog>

                                                    </div>
                                                )
                                                    : (
                                                        <div className="flex items-center">
                                                            <IconButton
                                                                title='Edit'
                                                                className={classes.smaller}
                                                                disabled
                                                            >
                                                                <Icon className=''>mode_edit</Icon>
                                                            </IconButton>
                                                            <IconButton
                                                                title='Activate'
                                                                className={classes.smaller}
                                                                onClick={(ev) => {
                                                                    ev.stopPropagation();
                                                                    this.activateBook(row.original.ID_PETTY_CASH_BOOK);
                                                                }}
                                                            >

                                                                <Icon className='text-red-light'>
                                                                    cancel
                                                                </Icon>
                                                            </IconButton>
                                                        </div>
                                                    )}
                                            </div>

                                        )
                                    }

                                ]}
                                defaultPageSize={10}
                                noDataText="No Petty Cash Books found"
                            />
                        </div>
                    </div>

                </React.Fragment>
            );
        }
    }

    componentWillMount() {

        this.getBook();
    }
}

export default withStyles({ withTheme: true })(withRouter(connect()(withAlert(pettyCashBook))));


// WEBPACK FOOTER //
// ./src/main/content/accounting/pettyCash/pettyCashBook.js